fx.ns("models", class DuplicateCluster extends fx.Model {

	constructor(data)
	{
		super(data);
    }

	get storable()
	{
		return false;
	}
});
